export function isTouchSupported(): boolean {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        // @ts-ignore TODO seems there is no this property in browser from what ts type error said
        (navigator.msMaxTouchPoints > 0));
}
